import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-nearby-amenities',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './nearby-amenities.component.html'
})
export class NearbyAmenitiesComponent {

  @Input() amenities: any = [];

  itemsPerPageOptions = [5, 10, 15, 20, 50];
  allData: any[] = [];
  paginatedData: any[] = [];

  currentPage = 1;
  itemsPerPage = 20;
  totalPages = 1;

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  ngOnInit() {
    // example: fetch data
    this.allData = this.getData();
    // this.applyPagination();
    this.sortData('property_name')
  }

  applyPagination() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.totalPages = Math.ceil(this.allData.length / this.itemsPerPage);
    this.paginatedData = this.allData.slice(start, end);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.applyPagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.applyPagination();
    }
  }

  goToFirstPage() {
    this.currentPage = 1;
    this.applyPagination();
  }

  goToLastPage() {
    this.currentPage = this.totalPages;
    this.applyPagination();
  }


  onItemsPerPageChange() {
    this.currentPage = 1;
    this.applyPagination();
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.allData.sort((a, b) => {
      const valA = a[column]?.toString().toLowerCase() || '';
      const valB = b[column]?.toString().toLowerCase() || '';

      if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.applyPagination();
  }

  getData() {
    // Replace this with your actual data load
    return this.amenities ?? []
  }

}
